import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router'
import { bindActionCreators } from 'redux'

import { session, drive } from 'gipsy-api'
import { translations } from 'gipsy-misc'

import { openPopup } from 'features/popup/store/actions'
import { handleAPIError } from 'features/app/store/actions'
import { driveOauthLocalStorageKey } from 'features/incrementalCallback'
import { fromOnboarding } from 'pages/onboarding'
import { extractStateParameters } from 'pages/incrementalCallback/utils'

import qs from 'qs'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      openPopup,
      handleAPIError
    },
    dispatch
  )
})

class DriveOauthCallback extends Component {
  constructor(props) {
    super(props)

    this.state = {
      redirect: false
    }
  }

  componentDidMount = async () => {
    const searchParams = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
    if (searchParams.error || !searchParams.code) {
      this.setState({
        redirect: true
      })
      return
    }
    try {
      await this.handleOAuthCallback()
    } catch (err) {
      this.props.actions.handleAPIError(err)
    }
  }

  handleOAuthCallback = async () => {
    const { error, state, localStateGoogle, localStateMicrosoft, code, nonce } = extractStateParameters(
      this.props.location
    )

    const querySucceeded = !error && code
    if (!querySucceeded) {
      throw new Error('Query failed.')
    }
    if (state === localStateGoogle) {
      const redirectURL = window.location.origin + '/driveoauthcallback'
      const emailToSync = await session.incrementalOauth('google', code, nonce, redirectURL)

      await drive.activateShareDocs(emailToSync)

      const driveSyncLocalStorageValue = window.sessionStorage.getItem(driveOauthLocalStorageKey)
      window.sessionStorage.removeItem(driveOauthLocalStorageKey)

      if (driveSyncLocalStorageValue === fromOnboarding) {
        this.setState({
          redirect: '/onboarding',
          emailToSync: emailToSync
        })
      } else {
        const popupContent = {
          message: translations.driveOauthCallback.success,
          button: translations.general.ok.toUpperCase(),
          action: 'onClose'
        }

        this.props.actions.openPopup(popupContent, 15 * 1000)
        this.setState({
          redirect: '/settings'
        })
      }
    } else if (state === localStateMicrosoft) {
      console.warn("We don't support microsoft sync for now")
      return
    } else {
      throw new Error('Unknown OAuth method.')
    }
  }

  render = () => {
    if (this.state.redirect === '/onboarding' && this.props.location.pathname !== '/onboarding') {
      return (
        <Redirect
          to={{
            pathname: this.state.redirect,
            state: { step: 5, emailToSync: this.state.emailToSync }
          }}
        />
      )
    }
    if (this.state.redirect === '/settings' && this.props.location.pathname !== '/settings') {
      return <Redirect to={this.state.redirect} />
    }
    return <div />
  }
}

export default connect(
  null,
  mapDispatchToProps,
  null,
  {
    pure: true
  }
)(DriveOauthCallback)



// WEBPACK FOOTER //
// ./src/pages/incrementalCallback/drive/index.js